import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import {addPrefix} from "../../../utils/UriUtil";
import {number_format} from "../../../utils/formatter";

class ListWriteTitle extends Component {

    constructor(props) {
        super(props);
        this.makeWriteUrl = this.makeWriteUrl.bind(this);
    }

    makeWriteUrl() {
        const {type, headLabel} = this.props;

        return <a href={ addPrefix(`/manage/${type}?returnURL=${location.pathname}`)} className="link_write">
            {headLabel} 쓰기
            <span className="ico_blog"/>
        </a>
    }

    render() {

        const { searchKeyword, totalCount, headLabel } = this.props;

        if(searchKeyword && searchKeyword != ''){

            return (
                <h3 className="tit_cont">
                    <span className="txt_result">'{searchKeyword}'</span> 검색결과
                    <span className="txt_count">{ (totalCount >= 0) ? number_format(totalCount) : ''}</span>
                    <Link to={"?"} className="link_back">
                        <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
                    </Link>
                    {this.makeWriteUrl()}
                </h3>
            );
        }else{

            return (
                <h3 className="tit_cont">
                    {headLabel} 관리
                    <span className="txt_count"> {number_format(totalCount)}</span>
                    {this.makeWriteUrl()}
                </h3>
            );
        }
    }
}

export default ListWriteTitle;
